export const AppRoutes = {
  SIGN_UP: "/sign-up",
  LOGIN: "/login",
  HOME: "/home",
  PROFILE: "/profile/:userId",
};
